import inlineGallery from '../../../commons/gallery/inlineGallery';
import mainGallery from "../../../commons/gallery/mainGallery";
import photoComparator from "../../../commons/photoComparator/photoComparator";
import ViewCount from '../../../commons/js/modules/viewCount';
import LinksTooltip from '../../../commons/js/modules/linksTooltip/index';
import readMoreStyler from '../../../commons/js/modules/readMoreStyler/readMoreStyler';
import initInfiniteScroll from "../../../commons/infiniteScroll/initInfiniteScroll";
import bottomTagsShowMore from '../../../commons/js/news/bottomTagsShowMore';
import resizeFootballTables from '../../../commons/footbalTable/resizeFootballTables';


exports.inlineGallery = inlineGallery;
exports.linksTooltip = LinksTooltip;
exports.viewCount = ViewCount;
exports.readMoreStyler = readMoreStyler;
exports.initInfiniteScroll = initInfiniteScroll;
exports.mainGallery = mainGallery;
exports.bottomTagsShowMore = bottomTagsShowMore;
exports.photoComparator = photoComparator;

new resizeFootballTables();